<!--Editable: {{editable}}-->
<!--RequireMod: {{requireMod}}-->

<section class="bid-rate-summary">
  <form #selectPeriodForm="ngForm">
    <div *ngIf="editBidRates && requireMod" class="p-grid">
      <div class="p-col-12 p-md-4 p-lg-4">
        <div class="p-grid">
          <div class="p-col-12 p-md-4 p-lg-4">
            <label *ngIf="!(editBidRates && requireMod)">Year</label>
            <label *ngIf="(editBidRates && requireMod)">Year*</label>
          </div>
          <div class="p-col-12 p-md-8 p-lg-8">
            <p-dropdown [options]="fiscalYearDropdown" [placeholder]="Validation.DropdownPlaceholder" [required]="requireMod"
                        [showClear]="true" name="position" [autoWidth]="true"
                        [(ngModel)]="selectedYear" (onChange)="onChangeYear(selectedYear)"
                        required>
            </p-dropdown>
          </div>
        </div>
      </div>
      <div class="p-col-12 p-md-4 p-lg-4">
        <div class="p-grid">
          <div class="p-col-12 p-md-4 p-lg-4">
            <label *ngIf="!(editBidRates && requireMod)">Accounting Period</label>
            <label *ngIf="(editBidRates && requireMod)">Effective Accounting Period*</label>
          </div>
          <div class="p-col-12 p-md-8 p-lg-8">
            <p-dropdown [(ngModel)]="selectedAccountingPeriodId" [options]="accountingPeriodDropdown" [showClear]="true"
                        [placeholder]="Validation.DropdownPlaceholder" (onChange)="onChangeAccountingPeriod()"
                        id="accountingPeriodForSearch"
                        name="accountingPeriodForSearch" [required]="requireMod">
            </p-dropdown>
          </div>
        </div>
      </div>
      <div class="p-col-12 p-md-4 p-lg-4">
        <div class="p-grid">
          <div class="p-col-12 p-md-4 p-lg-4">
            <label *ngIf="!(editBidRates && requireMod)">Mod</label>
            <label *ngIf="(editBidRates && requireMod)">Mod*</label>
          </div>
          <div class="p-col-12 p-md-8 p-lg-8">
            <p-dropdown [options]="entityModDropdown" name="contractModId" [placeholder]="Validation.DropdownPlaceholder"
                        [(ngModel)]="selectedModId" [required]="requireMod"></p-dropdown>
          </div>
        </div>
      </div>
    </div>
  </form>


  <div class="p-grid">
    <div class="p-col-12 p-md-8 p-lg-8">
    </div>
    <div class="p-col-12 p-md-4 p-lg-4" style="text-align:right;">
      <button *ngIf="editable" class="icon-action" pButton icon="fa fa-pencil" type="button" (click)="onClickEditRates()" pTooltip="Refresh"
              label="Modify Bid Rates"
              tooltipPosition="top">
      </button>
    </div>

    <div class="p-col-12 p-md-12 p-lg-12">
      <form #bidRateForm="ngForm">
        <app-data-table [columns]="tableColumns" [value]="rateSummaries" sortField="poolType" [sortOrder]="PrimeNgConfig.TableAscSortOrder"
                        [disableSearch]="true" [searchCaptionTemplate]="searchCaptionTemplate" [rightCaptionTemplate]="rightCaptionTemplate"
                        [bodyTemplate]="bodyTemplate">

          <ng-template #searchCaptionTemplate>
            <div class="p-col-12 p-md-5 p-lg-5" style="text-align:left;">
              <span *ngIf="referenceIdentifier"> Rates for {{transaction | titleCase}} {{referenceIdentifier}}</span>
            </div>
            <div class="p-col-12 p-md-5 p-lg-5" style="text-align:left;">
              Current Period: {{currentAccountingPeriod?.periodAsString}}
            </div>
          </ng-template>

          <ng-template #rightCaptionTemplate>
            <button pButton type="button" class="icon-action" icon="fa fa-refresh" label="refresh"
                    (click)="onClickRefresh()">
            </button>
          </ng-template>

          <ng-template #bodyTemplate let-row="row" let-rowIndex="rowIndex" let-columns="columns">
            <tr>
              <td *ngFor="let col of columns" [ngSwitch]="col.field">
                <span class="p-column-title">{{col.header}}</span>
                <span class="p-cell">
                <div *ngSwitchCase="'bidRate'">
                  <div class="p-grid">
                    <div class="p-col-8 p-md-8 p-lg-8">
                      <span class="p-inputgroup">
                        <button *ngIf="!row?.bidRate" [disabled]="!editBidRates" pButton type="button" class="action-secondary" icon="fa fa-plus"
                                (click)="onClickInitializeBidRate(row)">
                        </button>
                        <input type="number" *ngIf="!(row?.bidRate === null || row?.bidRate === undefined)" [name]="row?.costPoolName"
                               [disabled]="!editBidRates || (requireMod && !selectPeriodForm.valid)"
                               [(ngModel)]="row.bidRateAsPercentage" (input)="onChangeBidRate(row)"
                               [pattern]="RegExp4DigitDecimal"
                               pInputText pKeyFilter="pnum" [size]="Validation.ProvisionalRateMaxLength" style="max-width:65px;"/>
                          <span class="p-inputgroup-addon" style="height:39px;padding-right:3px;">%</span>
                        <button class="help-tip" type="button" pButton icon="fa fa-info-circle"
                                pTooltip="Percentage must be a decimal number between 0 and 100 with up to 4 digits after the decimal point." tooltipPosition="top"></button>
                      </span>
                    </div>
                    <div *ngIf="row?.bidRateId" class="p-col-4 p-md-4 p-lg-4">
                        <button pButton (click)="showBidRateHistory(row.bidRateId, $event,op, actualTarget)" pTooltip="View Bid Rates"
                                class="icon-action" icon="fa fa-external-link" style="position: relative;top:10px;"></button>
                        <label #actualTarget></label>
                    </div>
                  </div>
                </div>
                <div *ngSwitchCase="'provisionalRate'">
                  <div *ngIf="row?.provisionalRate">
                     {{row[col.field] | percent:Format.RatioNumber}}
                  </div>
                  <div *ngIf="!row?.fiscalYearCostPoolId" style="text-align:center;">
                     N/A
                    <button pButton class="icon-negative" icon="fa fa-exclamation-triangle"
                            pTooltip="Fiscal Year Cost pools are not setup for current period" tooltipPosition="top">
                    </button>
                  </div>
                </div>
                <div *ngSwitchCase="'poolType'">
                    {{row[col.field] | titleCase}}
                </div>
                <div *ngSwitchCase="'actualRate'">
                  <div *ngIf="selectedAccountingPeriodId || currentAccountingPeriod"> {{row[col.field] | percent:Format.RatioNumber}} </div>
                  <div *ngIf="!(selectedAccountingPeriodId || currentAccountingPeriod)"> N/A
                     <button pButton icon="fa fa-info-circle" class="icon-action"
                             pTooltip="Select Accounting Period to view Actual Rates " tooltipPosition="top">
                      </button>
                    </div>
                </div>
                <div *ngSwitchDefault>{{row[col.field]}}</div>
              </span>
              </td>
            </tr>
          </ng-template>
        </app-data-table>
      </form>
    </div>

    <div class="p-col-12 p-md-12 p-lg-12">
      <button *ngIf="editBidRates" pButton class="button-inaction pull-right" (click)="onClickCancelEditRates()" label="Cancel" icon="fa fa-close"></button>
      <button *ngIf="editBidRates" [disabled]="(requireMod && !selectPeriodForm.valid) || !bidRateForm.valid"
              pButton type="button" class="button-action pull-right" icon="fa fa-check" label="Save" (click)="onClickSaveRates()">
      </button>
    </div>


  </div>

  <p-overlayPanel [showCloseIcon]="true" [style]="{'max-width':'700px','width':'100%'}" [dismissable]="false" #op (onBeforeHide)="clearRateHistory()">

    <app-data-table [columns]="rateHistoryTableColumns" [value]="selectedRateHistories" sortField="modNumber" [sortOrder]="PrimeNgConfig.TableAscSortOrder"
                    [disableSearch]="true">
    </app-data-table>

  </p-overlayPanel>
</section>




